import Article from '../../smoothr-web-app-core/models/Article';

export function findFeatureArticle(article: Article) {
	const findFeatureArray = [];

	if (article) {
		if (article?.compound?.allergens && article.compound.allergens['cerealsContainingGluten'] == true) {
			findFeatureArray.push('gluten');
		}
		if (article?.compound?.allergens && article.compound.allergens['peanutsAndProductsThereof'] == true) {
			findFeatureArray.push('peanut');
		}
		if (article?.compound?.allergens && article.compound.allergens['milkAndProductsThereof'] == true) {
			findFeatureArray.push('lactose');
		}
		if (article?.compound?.features?.spicyLevel) {
			findFeatureArray.push('spicy');
		}
	}

	return findFeatureArray;
}
